import { clsx } from 'clsx';
import { ButtonRecipe, buttonRecipe } from './button.css';
import { typographyRecipe } from '../typography/typography.css';

export type ButtonStylingProps = ButtonRecipe & {
  className?: string;
};

export const getButtonClassName = (p: ButtonStylingProps) =>
  clsx(
    buttonRecipe({
      size: p.size,
      variant: p.variant,
      color: p.color,
    }),
    typographyRecipe({
      variant: 'body',
      size: p.size ?? 'large',
    }),
    p.className,
  );
